import { render, staticRenderFns } from "./AccountHolderManagement.vue?vue&type=template&id=a8df72ca"
import script from "./AccountHolderManagement.vue?vue&type=script&lang=ts"
export * from "./AccountHolderManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports